import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SharedModule } from 'src/app/_shared/_shared.module';
import { BtnLinkComponent } from 'src/app/_shared/bloque-buttons/btn-link/btn-link.component';

@Component({
  selector: 'app-dialog-confirmacion-registro',
  standalone: true,
  imports: [SharedModule, BtnLinkComponent],
  templateUrl: './dialog-confirmacion-registro.component.html',
  styleUrl: './dialog-confirmacion-registro.component.scss'
})
export class DialogConfirmacionRegistroComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { returnUrl: string, isPlatformFactoring: boolean, domainUrl: string },
    public dialogRef: MatDialogRef<DialogConfirmacionRegistroComponent>,
  ) { }

  closeDialog():void{
    this.dialogRef.close();
  }
}
